'use client'

import { QRCodeSVG } from 'qrcode.react'

export type QrCodeProps = UiComponentProps<{
  url: string
  size: number
  title: string
}>

export function QrCode({
  url,
  size,
  title,
  className,
  id,
  'data-testid': dataTestId = 'qr-code',
}: QrCodeProps) {
  return (
    <QRCodeSVG
      id={id}
      value={url}
      size={size}
      data-testid={dataTestId}
      level="H"
      title={title}
      className={className}
    />
  )
}
